import React, { useState,useEffect } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import useStyles from "assets/jss/material-dashboard-react/components/customFilterStyle";


const ClearButton = (props) => {
  const { t } = useTranslation();
  const {
    onClear = () => {},
  } = props;

  const classes = useStyles();


  const clearState = () => {
    //window.location.reload();
    onClear();
  };

  

  return (
    <Grid item>
    <Button
      className={classes.clearFilter}
      style={{ color: 'white',backgroundColor: '#d50910' }}
      onClick={() => {
        clearState();
        // formik.resetForm();

        
      }}
    >
      {t("Reset Allowable Estate Details")}
    </Button>
  </Grid>
  );
};

ClearButton.propTypes = {
  onSubmit: PropTypes.func,
  onClear: PropTypes.func,
  filterFields: PropTypes.array,
  initialValues: PropTypes.object,
  noClearButton: PropTypes.bool,
  formik: PropTypes.object,
  validationSchema: PropTypes.object,
};

export default ClearButton;